const ChatTypes = {
  // Data fetching
  FETCH_CHAT_MESSAGES: 'FETCH_CHAT_MESSAGES',
  FETCH_CHAT_PARTICIPANTS: 'FETCH_CHAT_PARTICIPANTS',
  FETCH_UNREAD_MESSAGE_COUNT: 'FETCH_UNREAD_MESSAGE_COUNT',

  // CRUD operations
  SEND_CHAT_MESSAGE: 'SEND_CHAT_MESSAGE',
  UPDATE_CHAT_MESSAGE: 'UPDATE_CHAT_MESSAGE',
  DELETE_CHAT_MESSAGE: 'DELETE_CHAT_MESSAGE',
  MARK_MESSAGES_AS_READ: 'MARK_MESSAGES_AS_READ',

  // Real-time updates
  ADD_NEW_MESSAGE: 'ADD_NEW_MESSAGE',
  UPDATE_MESSAGE_STATUS: 'UPDATE_MESSAGE_STATUS',
  UPDATE_TYPING_STATUS: 'UPDATE_TYPING_STATUS',

  // UI state
  SET_ACTIVE_ROOM: 'SET_ACTIVE_ROOM',
  SET_CHAT_FILTER_DATA: 'SET_CHAT_FILTER_DATA',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',

  // Cleanup
  CHAT_CLEAR_REDUCER: 'CHAT_CLEAR_REDUCER',
  CLEAR_MESSAGES: 'CLEAR_MESSAGES',
  CLEAR_ERROR: 'CLEAR_ERROR',
};

export default ChatTypes;
